import React from 'react'
import { Text } from 'oio-react'
import PropTypes from 'prop-types'
import { useGlobalState } from 'src/sites/state'

const Subtitle = ({ children }) => {
   const { theme } = useGlobalState()

   return (
      <Text
         color={theme.subtitleColor}
         size={theme.subtitleSize}
         lineHeight={theme.subtitleLineHeight}>
         {children}
      </Text>
   )
}

Subtitle.propTypes = {
   children: PropTypes.node.isRequired
}

export default Subtitle
